import { FilterableQueryParams } from 'models/FilterableQueryParams';

export function allQueryParamsFalsy(
  queryParams: FilterableQueryParams
): boolean {
  if (queryParams.page) {
    return false;
  }
  if (queryParams.hasValidCertificate) {
    return false;
  }
  if (queryParams.sort) {
    return false;
  }
  return !queryParams.q;
}
